import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ModalRef} from "../../../tandem-core/models/modal-ref";

@Component({
  selector: 'tandem-date-validation-dialog',
  templateUrl: './date-validation-dialog.component.html',
  styleUrls: ['./date-validation-dialog.component.scss']
})
export class DateValidationDialogComponent implements OnInit {

  validationForm: FormGroup = new FormGroup<any>({});
  outlyingTransactionsCount = 0;
  public modalRef?: ModalRef

  constructor(private fb: FormBuilder) {
    this.outlyingTransactionsCount = this.modalRef?.data?.outlyingTransactionsCount;
  }

  ngOnInit(): void {
        this.validationForm = this.fb.group({
          approach: [null, Validators.required]
        })
    }

  onCancel() {
    this.modalRef?.close();
  }

  onSubmit() {
    this.modalRef?.close(this.validationForm.get('approach')?.value);
  }
}
